import { createRoutine } from 'redux-saga-routines';
import { APPROVALS_EVALUATE_ITEM } from 'types/approvals';
export const approvalsEvaluateItemRoutine = createRoutine(APPROVALS_EVALUATE_ITEM);
